import { render, staticRenderFns } from "./activitysItem.vue?vue&type=template&id=59dca345&scoped=true"
import script from "./activitysItem.vue?vue&type=script&lang=js"
export * from "./activitysItem.vue?vue&type=script&lang=js"
import style0 from "./activitysItem.vue?vue&type=style&index=0&id=59dca345&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59dca345",
  null
  
)

export default component.exports